import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import config from '../config';

function Unsubscribe() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    const handleUnsubscribe = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Token de desuscripción inválido');
        return;
      }

      try {
        const response = await fetch(`${config.API_BASE_URL}/api/subscriptions/unsubscribe/${token}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();

        if (data.success) {
          setStatus('success');
          setMessage(data.message);
          setEmail(data.email || '');
        } else {
          setStatus('error');
          setMessage(data.message || 'Error al procesar la desuscripción');
        }
      } catch (error) {
        console.error('Error:', error);
        setStatus('error');
        setMessage('Error al conectar con el servidor. Por favor, intenta de nuevo más tarde.');
      }
    };

    handleUnsubscribe();
  }, [token]);

  return (
    <div className="unsubscribe-page">
      <div className="unsubscribe-container">
        {status === 'loading' && (
          <div className="loading-state">
            <div className="spinner"></div>
            <h2>Procesando tu solicitud...</h2>
          </div>
        )}

        {status === 'success' && (
          <div className="success-state">
            <div className="success-icon">✓</div>
            <h2>Desuscripción exitosa</h2>
            <p className="message">{message}</p>
            <p className="info-text">
              Has sido desuscrito de este pedido de oración específico.
            </p>
            {email && (
              <p className="email-info">
                Email: <strong>{email}</strong>
              </p>
            )}
            <div className="action-buttons">
              <button onClick={() => navigate('/')} className="btn-primary">
                Volver al inicio
              </button>
            </div>
          </div>
        )}

        {status === 'error' && (
          <div className="error-state">
            <div className="error-icon">⚠️</div>
            <h2>Error en la desuscripción</h2>
            <p className="message">{message}</p>
            <div className="action-buttons">
              <button onClick={() => navigate('/')} className="btn-primary">
                Volver al inicio
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Unsubscribe;

